module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-3000-with-gift-19b50a0d.png";